import { createSlice } from "@reduxjs/toolkit";
import {
  fetchReportDetail,
  fetchReportList,
  fetchSaveReport,
  fetchScheduledReport,
  fetchScheduledReportDetailByID,
} from "./api";
import { loadingTypes } from "../../../Utils/constant";

const initialState = localStorage.getItem("reportDocument")
  ? JSON.parse(localStorage.getItem("reportDocument"))
  : {
      favouriteReport: { data: [], status: "idle" },
      saveReport: { data: [], status: "idle" },
      scheduledReport: { data: [], status: "idle" },
      scheduledReportDetailsById: { data: [], status: "idle" },
      runNewReport: {
        report: {},
        reportName: "",
        options: [],
      },
      reportList: { data: [], status: "idle" },
      reportDetail: { data: {}, status: "idle" },
      isSavedReport: false,
      scheduledReportDetails: { data: {}, status: "idle" }
    };

export const reportDocumentSlice = createSlice({
  name: "reportDocument",
  initialState,
  reducers: {
    setReportDocumentStatus: (state, action) => {
      state.favouriteReport.status = action.payload;
      state.saveReport.status = action.payload;
      state.scheduledReport.status = action.payload;
      state.reportList.status = action.payload;
      state.reportDetail.status = action.payload;
      state.scheduledReportDetails.status = action.payload;
    },
    setRunNewReport: (state, action) => {
      state.runNewReport = action.payload;
      localStorage.setItem("reportDocument", JSON.stringify(state));
    },
    resetReport: (state) => {
      return {
        favouriteReport: { data: [], status: "idle" },
        saveReport: { data: [], status: "idle" },
        scheduledReport: { data: [], status: "idle" },
        runNewReport: {
          report: {},
          reportName: "",
          options: [],
        },
        reportList: { data: [], status: "idle" },
        reportDetail: { data: {}, status: "idle" },
        scheduledReportDetails: { data: {}, status: "idle" },
        isSavedReport: false,
      };
    },
    resetReportDetailStatus: (state) => {
      state.reportDetail.status = "idle";
    },
    setReportDetail: (state, action) => {
      state.reportDetail.data = action.payload;
      state.reportDetail.status = "fulfilled";
    },
    setIsSavedReport: (state, action) => {
      state.isSavedReport = action.payload;
      localStorage.setItem("reportDocument", JSON.stringify(state));
    },
    setScheduledReportDetails: (state, action) => {
      state.scheduledReportDetails.data = action.payload;
      state.scheduledReportDetails.status = loadingTypes.fulfilled;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSaveReport.pending, (state) => {
      state.saveReport.status = "loading";
      state.favouriteReport.status = "loading";
    });
    builder.addCase(fetchSaveReport.fulfilled, (state, action) => {
      state.saveReport.data = action.payload;
      state.saveReport.status = "fulfilled";
      // state.favouriteReport.data = action.payload.favouriteReport;
      state.favouriteReport.status = "fulfilled";
    });
    builder.addCase(fetchSaveReport.rejected, (state) => {
      state.saveReport.status = "failed";
      state.favouriteReport.status = "failed";
    });
    builder.addCase(fetchScheduledReport.pending, (state) => {
      state.scheduledReport.status = "loading";
    });
    builder.addCase(fetchScheduledReport.fulfilled, (state, action) => {
      state.scheduledReport.data = action.payload;
      state.scheduledReport.status = "fulfilled";
    });
    builder.addCase(fetchScheduledReport.rejected, (state) => {
      state.scheduledReport.status = "failed";
    });

    builder.addCase(fetchScheduledReportDetailByID.pending, (state) => {
      state.scheduledReportDetailsById.status = "loading";
    });
    builder.addCase(
      fetchScheduledReportDetailByID.fulfilled,
      (state, action) => {
        state.scheduledReportDetailsById.data = action.payload;
        state.scheduledReportDetailsById.status = "fulfilled";
      },
    );
    builder.addCase(fetchScheduledReportDetailByID.rejected, (state) => {
      state.scheduledReportDetailsById.status = "failed";
    });

    builder.addCase(fetchReportList.pending, (state) => {
      state.reportList.status = "loading";
    });
    builder.addCase(fetchReportList.fulfilled, (state, action) => {
      state.reportList.data = action.payload;
      state.reportList.status = "fulfilled";
      localStorage.setItem("reportDocument", JSON.stringify(state));
    });
    builder.addCase(fetchReportList.rejected, (state) => {
      state.reportList.status = "failed";
    });

    builder.addCase(fetchReportDetail.pending, (state) => {
      state.reportDetail.status = "loading";
    });
    builder.addCase(fetchReportDetail.fulfilled, (state, action) => {
      state.reportDetail.data = action.payload;
      state.reportDetail.status = "fulfilled";
      localStorage.setItem("reportDocument", JSON.stringify(state));
    });
    builder.addCase(fetchReportDetail.rejected, (state) => {
      state.reportDetail.status = "failed";
    });
  },
});

export const {
  setReportDocumentStatus,
  setRunNewReport,
  resetReport,
  resetReportDetailStatus,
  setReportDetail,
  setIsSavedReport,
  setScheduledReportDetails,
} = reportDocumentSlice.actions;

export default reportDocumentSlice.reducer;
